import { render } from "./ViewControl.vue?vue&type=template&id=1afaa98a"
import script from "./ViewControl.vue?vue&type=script&lang=js"
export * from "./ViewControl.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__